/* eslint-disable react/jsx-filename-extension */
import React from "react";
import { Checkbox, Switch, Row, Col, Collapse } from "antd";
import { setIndexPermissions, setIndexEnabled } from "./Utils/indexPermissionHandler"

const { Panel } = Collapse;

const UserIndexPermission = ({
  disabledState,
  additionalParameters,
  indexPermissions,
  indexList = [],
  indexPermissionHandler,
  hmgPermissionUpdate
}) => {

  const indexPermissionUpdate = (e, hmgElemId, indexElemId) => {
    const updatedPermissionsArray = setIndexPermissions(
      "index_" +
      hmgElemId +
      "_" +
      indexElemId,
      e.target.checked,
      indexPermissions
    );
    hmgPermissionUpdate(updatedPermissionsArray)
  }

  const additionalParametersOnChange = (e) => {
    const indexPermissionData = setIndexEnabled(e, indexPermissions);
    indexPermissionHandler(indexPermissionData);
    const permissions = { ...indexPermissions };
    Object.keys(permissions).forEach((elm) => {
      permissions[elm] = true;
    });
    hmgPermissionUpdate(permissions);
  };

  return (
    <Collapse defaultActiveKey={["5_1"]} expandIconPosition="end">
      <Panel header="Index Permissions" key="5_1">
        <div className="is_form_2_a">
          <div className="is_form_2_aa">
            <Row>
              <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                <label>Index Permissions</label>
              </Col>
              <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                <Switch
                  disabled={disabledState}
                  checked={additionalParameters.indexEnabled}
                  onChange={additionalParametersOnChange}
                />
              </Col>
            </Row>
          </div>
          {indexList.map((hmgElem) => {
            return (
              <div className="is_form_2_aa" key={hmgElem._id}>
                <Row>
                  <Col xxl={3} xl={4} lg={5} md={5} sm={5} xs={24}>
                    <label>
                      {hmgElem.hmg_name} - {hmgElem.project_name}
                    </label>
                  </Col>
                  <Col xxl={21} xl={20} lg={19} md={19} sm={19} xs={24}>
                    <Row>
                      {hmgElem.indexes
                        ? hmgElem.indexes.map((indexElem) => {
                            return (
                              <Col xxl={3} xl={6} lg={6} sm={8}>
                                <Checkbox
                                  disabled={
                                    !additionalParameters.indexEnabled ||
                                    disabledState
                                  }
                                  checked={
                                    indexPermissions[
                                      "index_" +
                                        hmgElem._id +
                                        "_" +
                                        indexElem.index_id._id
                                    ] === true
                                  }
                                  onChange={(e) =>
                                    indexPermissionUpdate(
                                      e,
                                      hmgElem._id,
                                      indexElem.index_id._id,
                                    )
                                  }
                                >
                                  {indexElem.index_id.name}
                                </Checkbox>
                                {/* )} */}
                              </Col>
                            );
                          })
                        : null}
                    </Row>
                  </Col>
                </Row>
              </div>
            );
          })}
        </div>
      </Panel>
    </Collapse>
  );
};

export default UserIndexPermission;